'use client';

import { useEffect, useState } from 'react';
import { CsrEvent } from 'services/csr-audit-summary/types';
import { fetchCsrAuditSummary } from 'services/csr-audit-summary';

import CsrActionSummaryModal from './csr-action-summary-modal';
import {
  CART_ROUTE,
  CONTROL_CENTER_BLOCKS,
  PARTS_DAIGRAM
} from 'constants/links';
import { usePathname } from 'next/navigation';

type CsrActionSummaryContainerProps = {
  isRegisteredUser: boolean;
  dealerName: string;
  isCatCsrUser: boolean;
  isBuyOnBehalf: boolean;
  isRegularCustomer: boolean;
};

const allowedPaths = [CONTROL_CENTER_BLOCKS, PARTS_DAIGRAM, CART_ROUTE];

const isAllowedPath = (currentPath: string) => {
  return allowedPaths.some(allowedPath => {
    // To extract path without query params
    const normalizePath = currentPath.split('?')[0];
    // Checking if the normalizePath ends with allowedPath
    return normalizePath.endsWith(allowedPath);
  });
}

function CsrActionSummaryContainer(
  props: Readonly<CsrActionSummaryContainerProps>
) {
  const {
    isRegisteredUser,
    dealerName,
    isCatCsrUser,
    isBuyOnBehalf,
    isRegularCustomer
  } = props;
  const [csrEvents, setCsrEvents] = useState<CsrEvent[] | null>();
  const [modalVisible, setModalVisible] = useState(false);
  const currentPath = usePathname();

  async function fetchApi() {
    const csrAuditSummaryResponse = await fetchCsrAuditSummary();

    if (csrAuditSummaryResponse?.csrEvents?.length) {
      setCsrEvents(csrAuditSummaryResponse.csrEvents);
      setModalVisible(true);
    }
  }

  const handleClose = () => {
    setModalVisible(false);
  };

  useEffect(() => {
    if (!isRegisteredUser && !dealerName) return;

    if (isCatCsrUser || isBuyOnBehalf) return;

    if (!isRegularCustomer) return;

    if(!isAllowedPath(currentPath)) return;

    fetchApi();
  }, [
    isRegisteredUser,
    dealerName,
    isCatCsrUser,
    isBuyOnBehalf,
    isRegularCustomer,
    currentPath
  ]);

  if (!modalVisible) return null;

  return (
    <CsrActionSummaryModal
      csrEvents={csrEvents}
      handleClose={handleClose}
      modalVisible={modalVisible}
    />
  );
}

export default CsrActionSummaryContainer;
